import { useSelector } from 'react-redux';

export default function usePriceSection() {
  const {filterOptionList, priceRange} = useSelector(({ product }) => product);
  let priceSection = filterOptionList?.price_section;
  return priceRange ?? priceSection;  
}